export class ResourceSnapshot {
    'properties';
    'tags';
    'cloudProvider';
    'resourceType';
    'providerResourceId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "properties",
            "baseName": "properties",
            "type": "ResourceSnapshotProperties",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceType",
            "format": ""
        },
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ResourceSnapshot.attributeTypeMap;
    }
    constructor() {
    }
}
